import React from 'react';

import { Box, Spinner } from '@betterment/samba-react';

export interface FullPageLoaderProps {
  text?: React.ReactNode;
}

export const FullPageLoader: React.FC<FullPageLoaderProps> = ({ text }) => (
  <Box
    css={{
      display: 'flex',
      flexDirection: 'column',
      height: '100vh',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 'space.200',
    }}
  >
    <Spinner size="lg" variant="primary" />
    {text && (
      <Box css={{ display: 'flex', flexDirection: 'column', textAlign: 'center', gap: 'space.100' }}>{text}</Box>
    )}
  </Box>
);
